import React from 'react';
import PropTypes from 'prop-types';
import { InputTextArea } from '@spark';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';

/**
 * Multi-line text field with the Figma label row (required asterisk + help
 * tooltip) on top of a Spark `InputTextArea`. `height` matches the fixed
 * textarea heights in the Figma frames (147 / 110 / 101 / 94 / 193 px).
 */
const TextAreaField = ({
    label,
    required = false,
    help,
    placeholder,
    value,
    onChange,
    height = 101,
    error = false,
    disabled = false,
    readOnly = false,
}) => (
    <div className={`gdai-field${error ? ' gdai-field--error' : ''}`}>
        <FieldLabel text={label} required={required} help={help} />
        <InputTextArea
            className="gdai-textarea"
            showLabel={false}
            size="medium"
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            readOnly={readOnly}
            style={{ '--gdai-textarea-height': `${height}px` }}
            onChange={(event) => onChange(event.target.value)}
        />
    </div>
);

TextAreaField.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    help: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    height: PropTypes.number,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

export default TextAreaField;
